import actions from '../../actionTypes';

export default () => {
  return {
    type: actions.LOGGED_OUT
  };
};



// WEBPACK FOOTER //
// ./src/reducers/auth/actions/loggedOut.js